import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';

const SharedToggleButton = ({ shared = false, onToggle, disabled = false }) => {
  const label = shared ? 'Shared' : 'Not shared';
  const hoverLabel = shared
    ? 'Click to stop sharing with Lead Agents'
    : 'Click to share with Lead Agents';

  return (
    <Tooltip title={hoverLabel} arrow placement='top'>
      <span>
        <Button
          size='small'
          disabled={disabled}
          onClick={onToggle}
          aria-label={hoverLabel}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 12,
            lineHeight: 1.2,
            minWidth: 0,
            px: 1.25,
            py: 0.35,
            borderRadius: 999,
            flexShrink: 0,
            boxShadow: 'none',
            bgcolor: shared ? '#e8f5e9' : '#f1f5f9',
            color: shared ? '#2e7d32' : '#475569',
            '&:hover': {
              bgcolor: shared ? '#dcedc8' : '#e2e8f0',
              boxShadow: 'none',
            },
            '&.Mui-disabled': {
              bgcolor: shared ? '#e8f5e9' : '#f1f5f9',
              color: shared ? '#2e7d32' : '#475569',
              opacity: 0.7,
            },
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};

export const SharingInfoTooltipContent = ({ title, paragraphs = [] }) => (
  <Box sx={{ p: 0.25, maxWidth: 300 }}>
    <Typography variant='subtitle2' fontWeight={700} mb={1} color='#fff'>
      {title}
    </Typography>
    {paragraphs.map((paragraph) => (
      <Typography
        key={paragraph}
        variant='caption'
        display='block'
        sx={{ color: 'rgba(255,255,255,0.92)', lineHeight: 1.45, mb: 1, '&:last-child': { mb: 0 } }}
      >
        {paragraph}
      </Typography>
    ))}
  </Box>
);

export default SharedToggleButton;
